// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"f7ff2d4a","453":"9c8156db","796":"323c0d70"}[chunkId] + ".chunk.js";
};